import { render, staticRenderFns } from "./TabelaCorpo.vue?vue&type=template&id=1e89fa5b&scoped=true&lang=pug"
import script from "./TabelaCorpo.vue?vue&type=script&lang=js"
export * from "./TabelaCorpo.vue?vue&type=script&lang=js"
import style0 from "./TabelaCorpo.styl?vue&type=style&index=0&id=1e89fa5b&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e89fa5b",
  null
  
)

export default component.exports